import React from "react";
import { LogoRound } from "../../../../widget/common/ui/Logo";
import AppConfigService from "../../../../service/app_config/AppConfigService";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import { SpacingHeight } from "../../../../widget/common/ui/Spacing";
import { TextBlock } from "../../../../widget/common/ui/Text";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import Div from "../../../../widget/common/ui/Div";
import Center from "../../../../widget/common/ui/Center";

type CompanyLogoProps = {
  title: string;
  logoSize?: number;
};
export const CompanyLogo: React.FC<CompanyLogoProps> = ({
  title = "",
  logoSize,
}) => {
  const type: number = ResponsiveDeviceType();

  return (
    <Div>
      <Center>
        <LogoRound
          url={AppConfigService.get("company_logo")}
          name={AppConfigService.get("company_name")}
          className="login-logo"
          size={logoSize ?? type === 1 ? 100 : 150}
        />
      </Center>
      <SpacingHeight value={type === 3 ? 50 : 30} />
      <TextBlock
        center={true}
        fontSize="16_17"
        fontName="bold"
        textColor="theme-label"
      >
        {AppTranslation.text(title)}
      </TextBlock>
      <SpacingHeight value={type === 1 ? 35 : type === 2 ? 48 : 45} />
    </Div>
  );
};
